import { lazy, Suspense } from "react";
import Layout from "./Layout.jsx";
import Landing from "./Landing";
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';

const ROUTER_BASENAME = /^\/frontend(?:\/|$)/i.test(window.location.pathname) ? '/frontend' : '/';

const Booking = lazy(() => import("./Booking"));
const AdminDashboard = lazy(() => import("./AdminDashboard"));
const AdminBookings = lazy(() => import("./AdminBookings"));
const AdminPlatforms = lazy(() => import("./AdminPlatforms"));
const AdminCustomers = lazy(() => import("./AdminCustomers"));
const AdminCalendar = lazy(() => import("./AdminCalendar"));
const AdminSettings = lazy(() => import("./AdminSettings"));
const AdminInvoices = lazy(() => import("./AdminInvoices"));
const Impressum = lazy(() => import("./Impressum"));
const Datenschutz = lazy(() => import("./Datenschutz"));
const InquirySuccess = lazy(() => import("./InquirySuccess"));
const AdminSiteContent = lazy(() => import("./AdminSiteContent"));
const AdminLogin = lazy(() => import("./AdminLogin"));
const PaymentSuccess = lazy(() => import("./PaymentSuccess"));
const ServiceDetail = lazy(() => import("./ServiceDetail"));
const Blog = lazy(() => import("./Blog"));
const BlogPost = lazy(() => import("./BlogPost"));

const PAGES = {
    
    Landing: Landing,
    
    Booking: Booking,
    
    AdminDashboard: AdminDashboard,
    
    AdminBookings: AdminBookings,
    
    AdminPlatforms: AdminPlatforms,
    
    AdminCustomers: AdminCustomers,
    
    AdminCalendar: AdminCalendar,
    
    AdminSettings: AdminSettings,
    
    AdminInvoices: AdminInvoices,
    
    Impressum: Impressum,
    
    Datenschutz: Datenschutz,
    
    InquirySuccess: InquirySuccess,
    
    AdminSiteContent: AdminSiteContent,
    
    AdminLogin: AdminLogin,
    
    PaymentSuccess: PaymentSuccess,

    ServiceDetail: ServiceDetail,

    Blog: Blog,

    BlogPost: BlogPost,
    
}

function _getCurrentPage(url) {
    if (url.endsWith('/')) {
        url = url.slice(0, -1);
    }

    const normalizedUrl = url || '/';
    const adminPageByPath = {
        '/admin': 'AdminLogin',
        '/admin/dashboard': 'AdminDashboard',
        '/admin/bookings': 'AdminBookings',
        '/admin/maschinen': 'AdminPlatforms',
        '/admin/kunden': 'AdminCustomers',
        '/admin/kalender': 'AdminCalendar',
        '/admin/einstellungen': 'AdminSettings',
        '/admin/rechnungen': 'AdminInvoices',
        '/admin/inhalte': 'AdminSiteContent',
    };

    const adminPage = adminPageByPath[normalizedUrl.toLowerCase()];
    if (adminPage) {
        return adminPage;
    }

    if (normalizedUrl === '/blog') {
        return 'Blog';
    }

    if (normalizedUrl.startsWith('/blog/')) {
        return 'BlogPost';
    }

    const servicePaths = ['/arbeitsbuehnen-mieten', '/lieferung-aufbau', '/einweisung', '/support-24-7'];
    if (servicePaths.includes(normalizedUrl.toLowerCase())) {
        return 'ServiceDetail';
    }

    let urlLastPart = url.split('/').pop();
    if (urlLastPart.includes('?')) {
        urlLastPart = urlLastPart.split('?')[0];
    }

    const pageName = Object.keys(PAGES).find(page => page.toLowerCase() === urlLastPart.toLowerCase());
    return pageName || Object.keys(PAGES)[0];
}

// Create a wrapper component that uses useLocation inside the Router context
function PagesContent() {
    const location = useLocation();
    const currentPage = _getCurrentPage(location.pathname);
    
    return (
        <Layout currentPageName={currentPage}>
            <Suspense fallback={null}>
            <Routes>
                
                    <Route path="/" element={<Landing />} />
                
                
                <Route path="/Landing" element={<Landing />} />
                
                <Route path="/Booking" element={<Booking />} />

                <Route path="/arbeitsbuehnen-mieten" element={<ServiceDetail />} />
                <Route path="/lieferung-aufbau" element={<ServiceDetail />} />
                <Route path="/einweisung" element={<ServiceDetail />} />
                <Route path="/support-24-7" element={<ServiceDetail />} />

                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                
                <Route path="/admin" element={<AdminLogin />} />
                
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                
                <Route path="/admin/bookings" element={<AdminBookings />} />
                
                <Route path="/admin/maschinen" element={<AdminPlatforms />} />
                
                <Route path="/admin/kunden" element={<AdminCustomers />} />
                
                <Route path="/admin/kalender" element={<AdminCalendar />} />
                
                <Route path="/admin/einstellungen" element={<AdminSettings />} />
                
                <Route path="/admin/rechnungen" element={<AdminInvoices />} />
                
                <Route path="/Impressum" element={<Impressum />} />
                
                <Route path="/Datenschutz" element={<Datenschutz />} />
                
                <Route path="/InquirySuccess" element={<InquirySuccess />} />
                
                <Route path="/admin/inhalte" element={<AdminSiteContent />} />
                
                <Route path="/AdminDashboard" element={<Navigate to="/admin" replace />} />
                <Route path="/AdminBookings" element={<Navigate to="/admin" replace />} />
                <Route path="/AdminPlatforms" element={<Navigate to="/admin" replace />} />
                <Route path="/AdminCustomers" element={<Navigate to="/admin" replace />} />
                <Route path="/AdminCalendar" element={<Navigate to="/admin" replace />} />
                <Route path="/AdminSettings" element={<Navigate to="/admin" replace />} />
                <Route path="/AdminInvoices" element={<Navigate to="/admin" replace />} />
                <Route path="/AdminSiteContent" element={<Navigate to="/admin" replace />} />
                <Route path="/AdminLogin" element={<Navigate to="/admin" replace />} />
                
                <Route path="/PaymentSuccess" element={<PaymentSuccess />} />
                
            </Routes>
            </Suspense>
        </Layout>
    );
}

export default function Pages() {
    return (
        <Router basename={ROUTER_BASENAME}>
            <PagesContent />
        </Router>
    );
}
